// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__IeliI","footerLeft":"styles_footerLeft__rF1OQ","footerRight":"styles_footerRight__LNS20"};